import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { PostalCodeUtilsService } from '@core/utils/postal-code';
import { QueryAddressCoordinatesGQL, QueryAddressPostalCodeGQL } from 'app/main/locations/services/location.service';
import brAddressFormatter from 'br-address-formatter';
import { merge } from 'rxjs';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(postalCodeUtilsService, queryAddressPostalCodeGQL, queryAddressCoordinatesGQL) {
        this.postalCodeUtilsService = postalCodeUtilsService;
        this.queryAddressPostalCodeGQL = queryAddressPostalCodeGQL;
        this.queryAddressCoordinatesGQL = queryAddressCoordinatesGQL;
        this.postalCodeIsLoading = false;
        this.desiredStyle = searchManyInputStyles.Underline;
    }
    TabGeneralComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.locationForm.get('address').get('postalCode').valueChanges.pipe(debounceTime(1000), filter(function (postalCode) { return _this.postalCodeUtilsService.isValidFormat(postalCode) && postalCode.length === 8; })).subscribe(function (postalCode) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var address;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.locationForm.value.searchingWithGoogle) {
                            return [2 /*return*/];
                        }
                        this.postalCodeIsLoading = true;
                        this.locationForm.get('address').get('city').setValue(null);
                        this.locationForm.get('address').get('streetName').setValue(null);
                        this.locationForm.get('address').get('neighborhood').setValue(null);
                        this.locationForm.get('address').get('state').setValue(null);
                        return [4 /*yield*/, this.queryAddressPostalCodeGQL.fetch({ postalCode: postalCode })
                                .toPromise()
                                .then(function (response) { return response.data && response.data.addressPostalCode; })
                                .catch(function () { return null; })];
                    case 1:
                        address = _a.sent();
                        if (address) {
                            this.locationForm.get('address').get('city').setValue(address.city);
                            this.locationForm.get('address').get('streetName').setValue(address.streetName);
                            this.locationForm.get('address').get('neighborhood').setValue(address.neighborhood);
                            this.locationForm.get('address').get('state').setValue(address.state);
                        }
                        this.postalCodeIsLoading = false;
                        return [2 /*return*/];
                }
            });
        }); });
        merge(this.locationForm.get('address').get('city').valueChanges, this.locationForm.get('address').get('streetName').valueChanges, this.locationForm.get('address').get('neighborhood').valueChanges, this.locationForm.get('address').get('state').valueChanges, this.locationForm.get('address').get('number').valueChanges).pipe(debounceTime(1000), map(function () {
            return brAddressFormatter(tslib_1.__assign({}, _this.locationForm.get('address').value, { street: _this.locationForm.get('address').value.streetName }));
        }), filter(function (formattedAddress) { return !!formattedAddress; }), switchMap(function (formattedAddress) {
            return _this.queryAddressCoordinatesGQL.fetch({ address: formattedAddress })
                .toPromise()
                .catch(function () { return null; })
                .then(function (response) {
                return response && response.data && response.data.addressCoordinates;
            });
        })).subscribe(function (coordinates) {
            var latitude = (coordinates && coordinates.latitude) || null;
            var longitude = (coordinates && coordinates.longitude) || null;
            _this.locationForm.get('address').get('coords').get('latitude').setValue(latitude);
            _this.locationForm.get('address').get('coords').get('longitude').setValue(longitude);
            _this.locationForm.get('address').get('formattedAddress').setValue(brAddressFormatter(tslib_1.__assign({}, _this.locationForm.get('address').value, { street: _this.locationForm.get('address').value.streetName })));
        });
    };
    TabGeneralComponent.prototype.onInput = function (event) {
        var input = event.target;
        input.value = input.value.replace(/[^a-zA-Z0-9]/g, '');
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
